module.exports = __webpack_public_path__ + "img/trip_06.b0599898.jpg";